import "mapbox-gl/dist/mapbox-gl.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { LocationOn, Phone, AlternateEmail, Link } from "@material-ui/icons";
import { css } from "emotion";

interface Props {}

const GetInTouch: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <>
      <h1>{t(`contact.get_in_touch`)}</h1>
      <p className="head">
        <LocationOn />
        <strong>{t(`contact.address`)}</strong>
      </p>
      <p>Frans van Ryhovelaan 148 9000, Gent/België</p>

      <p className="head">
        <Phone />
        <strong>{t(`contact.phone`)}</strong>
      </p>
      <p>
        <a href="tel:(09) 357 69 11">(09) 357 69 11</a>
      </p>
      <p className="head">
        <AlternateEmail />
        <strong>{t(`contact.email`)}</strong>
      </p>
      <p>
        <a href="mailto:erbasupermarkt@hotmail.com">erbasupermarkt@hotmail.com</a>
      </p>

      <p className="head">
        <Link />
        <strong>{t(`contact.website`)}</strong>
      </p>
      <p>
        <a href="http://erbasupermarkt.com" target="_blank" rel="noopener noreferrer">
          erbasupermarkt.com
        </a>
      </p>

      <p className="head">
        <strong>{t(`contact.follow`)}</strong>
      </p>
      <a href="https://www.facebook.com/erbasupermarkt/" target="_blank" rel="noopener noreferrer">
        <img src="./assets/facebook.svg" alt="facebook" />
      </a>
      <a
        href="https://instagram.com/erbasupermarkt"
        target="_blank"
        rel="noopener noreferrer"
        className={css({ margin: "0 0.5rem" })}
      >
        <img src="./assets/instagram.svg" alt="instagram" />
      </a>
    </>
  );
};

export default GetInTouch;
